const foodExcludedFromDiet = {
  meatBeefPorkLambEtc        : 'Meat',
  poultryChickenTurkeyDuck   : 'Poultry',
  fishAndSeafood             : 'Fish and sea food',
  eggs                       : 'Eggs',
  dairyProductsMilkCheeseEtc : 'Diary products',
};

const OtherTypeOfDiets = {
  diabeticLowSugarLowCarbohydrate     : 'Diabetic Low Sugar Low Carbohydrate',
  ketogenic                           : 'Ketogenic',
  lowFatOrCardiovascularDiet          : 'Low Fat Or Cardiovascular Diet',
  lowPhosphorus                       : 'Low Phosphorus',
  lowPotassium                        : 'Low Potassium',
  lowProtein                          : 'Low Protein',
  lowSodium                           : 'Low Sodium',
  otherWholeFoodPaleoEtcPleaseSpecify : 'Other',
};

export const getDietConsiderations = (dietConsiderations) => {
  const entries = dietConsiderations?.taskEntry;
  if (!entries) {
    return [];
  }
  const foodExcludedFromDietEntries =
    entries?.whichOfTheFollowingFoodsIfAnyDoYouExcludeFromYourDietCheckAllThatApply;
  let foods = '';
  for (const key in foodExcludedFromDietEntries) {
    const entry = foodExcludedFromDietEntries[key];
    if (entry) {
      foods += `${foodExcludedFromDiet[key]}, `;
    }
  }

  const OtherTypeOfDietEntries =
    entries?.doYouFollowAnyOtherTypeOfDietCheckAllThatApply;
  let otherDiets = '';
  for (const key in OtherTypeOfDietEntries) {
    const entry = OtherTypeOfDietEntries[key];
    if (entry) {
      otherDiets += `${OtherTypeOfDiets[key]}, `;
    }
  }

  // whatIsYourCurrentHeightFeet6 to be replaced
  const waterPerDay = entries?.whatIsYourCurrentHeightFeet6;

  const diets = [
    {
      key   : 'Number of cups (8oz) of water per day on average',
      value : waterPerDay,
    },
    { key: 'Foods excluded from diet', value: foods.replace(/,\s*$/, '') },
    { key: 'Other types of diets', value: otherDiets.replace(/,\s*$/, '') },
  ].filter((diet) => diet.value !== '' || diet.value !== null);

  return diets;
};
